// NotificationHandler.js
import { useEffect } from "react";
import { messaging } from "./firebase-config";
import { getToken, onMessage, isSupported } from "firebase/messaging";
import { setFcmToken } from "../utils/token";

const VAPID_KEY =
  "BEL8ttcmQ_hcsIGlak_kisgPQgYyMTHNnGJ__47F2nv6Cadp7o4i7sxoCKDrjD0iuTw0hdpKno53MqpES7J3REY"; // Ask your backend team if they use one

// Detect if running on iOS
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

const NotificationHandler = () => {
  useEffect(() => {
    async function initMessaging() {
      try {
        // iOS (Safari and Chrome) don't support Web Push APIs
        if (isIOS) {
          console.warn("Push notifications are not supported on iOS. Web push requires native app integration.");
          return;
        }

        // First check if Firebase Messaging APIs are supported
        const supported = await isSupported();
        if (!supported) {
          console.warn("Push messaging is not supported in this browser.");
          return;
        }

        // Then check if Notification API exists
        if (!("Notification" in window)) {
          console.warn("Notifications API is not available in this browser.");
          return;
        }

        console.log("Requesting notification permission...");
        const permission = await Notification.requestPermission();

        if (permission === "granted" && messaging) {
          try {
            const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
            if (currentToken) {
              console.log("FCM Token:", currentToken);
              setFcmToken(currentToken);
              // Send this token to backend
            } else {
              console.warn("No registration token available");
            }
          } catch (err) {
            console.error("Error retrieving FCM token:", err);
          }
        }

        // ✅ Foreground messages
        if (messaging) {
          onMessage(messaging, (payload) => {
            console.log("Foreground message:", payload);
            const { title, body } = payload.notification || {};
            if (title && body && "Notification" in window) {
              new Notification(title, {
                body,
                icon: "/logo192.png",
              });
            }
          });
        }
      } catch (err) {
        console.error("FCM init failed:", err);
      }
    }

    initMessaging();
  }, []);

  return null;
};

export default NotificationHandler;
